import React from 'react'
import { Meta, MetaTitle, MetaView } from './styles'
import { Text } from 'styles/reactnative'
import PhoneSelect from '../PhoneSelect'

const PhoneSelection = ({ phone, setPhone, phoneCode, setPhoneCode }) => {
	return (
		<MetaView>
			<MetaTitle>
				<Text>{'휴대폰'}</Text>
			</MetaTitle>
			<Meta
				style={{
					background: 'transparent',
					padding: 0,
				}}>
				<PhoneSelect
					phone={phone}
					setPhone={setPhone}
					phoneCode={phoneCode}
					setPhoneCode={setPhoneCode}
				/>
			</Meta>
		</MetaView>
	)
}

export default PhoneSelection
